import { cn } from '@/utlis/cn'
import React from 'react'

type CircleIconButtonProps = {
    children: React.ReactNode
    className?: string
} & React.ButtonHTMLAttributes<HTMLButtonElement>

export const CircleIconButton = React.forwardRef<HTMLButtonElement, CircleIconButtonProps>(
    ({ children, className, ...rest }: CircleIconButtonProps, forwardedRef) => {
        const border = 'rounded-[70px] border-muse-toplit'
        const style = 'cursor-pointer h-[40px] w-[40px] min-w-[40px] flex items-center justify-center'
        const bg = 'backdrop-blur-xs hover:bg-white/10'
        return (
            <button className={cn(border, style, bg, className)} {...rest} ref={forwardedRef}>
                {children}
            </button>
        )
    }
)
